// extracted by mini-css-extract-plugin
export default {"DimensionsFeature":"vx_a bhk_b bhk_wb"};